<div class="form-group switch-container">
  <label for="" class="form-label">
    {{label}}
    @if (labelDesc) {
      <span class="switch-desc">{{labelDesc}}</span>
    }
  </label>
  <div class="md-switch">
    <input type="checkbox"
      #switchBtn
      [disabled]="disableBtn"
      id="switch-{{labelEn}}"
      [(ngModel)]="value"
      [checked]="value"
      (change)="changeValue($event.target)"
      name="switch-{{labelEn}}"
      class="md-toggle md-toggle-round">
      <label for="switch-{{labelEn}}"></label>
    </div>
  </div>
